import { Injectable, OnDestroy, OnInit } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { UserService } from "./user.service";
import { CommercialService } from "./commercial.service";
import {
  Headers,
  Http,
  RequestOptions,
  Response,
  ResponseContentType,
} from "@angular/http";
import { Constants } from "@app/constants";
import { Subscription } from "rxjs/Subscription";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/Rx";
import { Commercial, User } from "@shared/models";
import * as moment from "moment";
import { LoadingService } from "./loading.service";

@Injectable()
export class AuthGuardService implements CanActivate, OnDestroy, OnInit {
  private user: any;
  private commercialValue: Commercial;
  private subscription: Subscription;
  private commercialSubscription: Subscription;

  private gettingAccountDetailsFlag = new BehaviorSubject<boolean>(false);
  detailsFlagChange$ = this.gettingAccountDetailsFlag.asObservable();
  private gettingAccountDetailsCustomerId: number;
  startDate = moment().subtract(1, "months");
  endDate = moment();
  private resultingJSON: any;

  public showContent = false;

  private static setAuthenticatedHeadersForFiles() {
    const token = localStorage.getItem(Constants.TOKEN)
      ? localStorage.getItem(Constants.TOKEN)
      : sessionStorage.getItem(Constants.TOKEN);
    const headers = new Headers({
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    });
    return new RequestOptions({
      headers: headers,
      responseType: ResponseContentType.Blob,
    });
  }

  private static setAuthenticatedHeaders() {
    const token = localStorage.getItem(Constants.TOKEN)
      ? localStorage.getItem(Constants.TOKEN)
      : sessionStorage.getItem(Constants.TOKEN);
    const headers = new Headers({
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    });
    return new RequestOptions({ headers: headers });
  }

  constructor(
    private _service: UserService,
    private _router: Router,
    private _http: Http,
    private _loading: LoadingService,
    private _commercialService: CommercialService
  ) {
    this.subscription = this._service.getUser().subscribe((user) => {
      this.user = user;
    });

    this.commercialSubscription = this._commercialService
      .getCommercialValue()
      .subscribe((commercial) => {
        this.commercialValue = commercial;
      });
  }

  ngOnInit() {
    this.subscription = this._service.getUser().subscribe((user) => {
      this.user = user;
    });
    this.getAccountInfo();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // This should eventually be refactored along with authenteicatedPost?
  // All http request shouldn't be called under to POST endpoint.  Refactor to
  // follow restful standards?
  public authenticatedFileRetrieval(api: string, body: any): Observable<any> {
    let url = Constants.NEXPRESS_ENDPOINT + api;
    let headers = AuthGuardService.setAuthenticatedHeaders();
    headers.responseType = ResponseContentType.Blob;

    return this._http
      .post(url, body, headers)
      .map((res) => {
        let header = res.headers.get("content-disposition");
        const filename = header
          .substring(header.indexOf("filename"), header.length)
          .split("=")[1];
        let response = (<any>res)._body;
        let data = {
          blob: new Blob([response], {
            type: "application/octet-stream;charset=utf-8",
          }),
          filename: filename,
        };
        return data;
      })
      .catch((error) => {
        console.log("authenticatedFileRetrieval: ", error);
        return Observable.throw("error");
      });
  }

  //
  public authenticatedPost(api: string, body: any): Observable<Response> {
    const url = Constants.NEXPRESS_ENDPOINT + api;
    //this._loading.showLoader();
    return this._http
      .post(url, body, AuthGuardService.setAuthenticatedHeaders())
      .map((res: Response) => {
        //this._loading.hideLoader();
        return res.json();
      })
      .catch((error: any) => {
        //this._loading.hideLoader();
        console.log("Authenticated post error:", error.json());
        console.log("Authenticated post ModelState:", error.json().ModelState);
        const mState = error.json().ModelState;
        let errorMessage = "";
        if (mState == null) {
          errorMessage = error.json().Message;
        } else {
          errorMessage = mState[Object.keys(mState)[0]];
        }
        return Observable.throw(errorMessage || "Server error");
      });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.determineIfTokenExpired()) {
      console.log("Token expired");
      sessionStorage.clear();
      localStorage.clear();
      this._service.changeLogInStatus(false);
      this._service.changeUser(
        new User("", "", "", "", 0, [], false, false, "")
      );
      this._router.navigate([Constants.NEXPRESS_HOME_PAGE]);
      return false;
    } else if (
      localStorage.getItem(Constants.TOKEN) ||
      sessionStorage.getItem(Constants.TOKEN)
    ) {
      this.getCurrentUser();
      if (state.url === "/autologin") {
        this._router.navigate(["/account"]);
      }
      return true;
    } else if (this.user.tokenKey === "") {
      sessionStorage.clear();
      localStorage.clear();
      this._router.navigate([Constants.NEXPRESS_HOME_PAGE]);
      return false;
    } else if (this.user) {
      this.getCurrentUser();
      if (state.url === "/autologin") {
        this._router.navigate(["/account"]);
      }
      return true;
    } else {
      // not logged in so redirect to login page with the return url
      this._router.navigate([Constants.NEXPRESS_HOME_PAGE]);
      return false;
    }
  }

  public getCurrentUser() {
    this.authenticatedPost("Account/AccountInfo", null).subscribe(
      (result) => {
        this.maybeSetCurrentUser(result);
      },
      (error) => console.log("Error: " + error)
    );
  }

  public logOut;

  public updateCustomerList() {
    let result_raw: any;
    let customerId;
    let index = null;
    this._loading.showLoader();
    this.authenticatedPost("Account/AccountInfo", null).subscribe(
      (result) => {
        this._loading.hideLoader();
        result_raw = result;
        console.log(result_raw);
        this.user.customerIdArray = result_raw.customerIdList;

        // Get customerId from local storage.
        if (localStorage.getItem("customerId")) {
          customerId = localStorage.getItem("customerId");
          console.log(customerId);
          index = result_raw.customerIdList.findIndex(function (x) {
            return x.Id == customerId;
          });
          if (index === -1) {
            index = 0;
          }
          console.log(index);
        }

        let customerIndex =
          index || Number.parseInt(localStorage.getItem("customerIndex")) || 0;
        console.log(result_raw.customerIdList);
        if (result_raw.customerIdList.length <= customerIndex)
          this.user.setCustomerIndex(0);
        else this.user.setCustomerIndex(customerIndex);
        console.log(this.user);
        this._service.changeUser(this.user);
        this.getAccountInfo();
        this.getCreditCards();
      },
      (error) => console.log("Error: " + error)
    );
  }

  private maybeSetCurrentUser(result) {
    if (undefined === this.user) {
      this._service.setUserData(result);
      this.getAccountInfo();
    } else if ("" === this.user.email) {
      this._service.setUserData(result);
      this.getAccountInfo();
      this._service.changeLogInStatus(true);
      //this._router.navigateByUrl('/account');
    }
  }

  getAccountInfo() {
    this._loading.showLoader();
    console.log(this.user);
    if (this.user.customerIdArray[this.user.customerIndex] == undefined) {
      this._loading.hideLoader();
      return;
    }
    const customerId = this.user.customerIdArray[this.user.customerIndex].Id;
    let data: string;
    data = JSON.stringify({ CustomerId: customerId });
    const accountSummaryUrl = "portfolios/AccountSummary";

    this.authenticatedPost(accountSummaryUrl, data).subscribe(
      (result) => {
        this._service.setAccountSummaryArray(result);
        this._commercialService.setCommercial();
        this.getAllAccountDetails();
        this.doRedirectAfterLogin();
        this._loading.hideLoader();
      },
      (error) => console.log("Error: " + error)
    );
  }

  getAllAccountDetails() {
    if (!this.gettingAccountDetailsFlag.value) {
      this.getAccountDetails(
        this.user.customerIdArray[this.user.customerIndex].Id,
        this.startDate,
        this.endDate
      );
    }
    return;
  }

  getAccountDetails(accountId, startDate, endDate) {
    let data: string;
    this.gettingAccountDetailsFlag.next(true);
    this.gettingAccountDetailsCustomerId = accountId;
    //remove all trips from database
    this._service.deleteTripsFromAccountDetailDatabase();

    data = JSON.stringify({
      CustomerId: accountId,
      StartDate: startDate,
      EndDate: endDate,
      IsBusiness: this.commercialValue.isCustomerCommercial,
    });
    const accountDetailUrl = "portfolios/AccountDetail";
    this.authenticatedPost(accountDetailUrl, data).subscribe(
      (result) => {
        this.gettingAccountDetailsFlag.next(false);
        if (
          this.gettingAccountDetailsCustomerId ==
          this.user.customerIdArray[this.user.customerIndex].Id
        ) {
          this.resultingJSON = JSON.parse(JSON.stringify(result));

          for (const account of this.user.accountSummaryArray) {
            console.log(this.user.accountSummaryArray);
            // setting length to zero would be better to clear any existing arrays
            this._service.createAccountDetailArray(account.id); // create an array for the trip list for every account id
          }

          for (const trip of this.resultingJSON.AccountDetails) {
            console.log(this.resultingJSON.AccountDetails);
            console.log(this._service);
            // push trip to the trip list. May need to clear list but the new array is probably handling that.
            this._service.addTripToAccountDetailArray(trip.AccountId, trip);
          }
          this._service.addTripsToAccountDetailDatabase(
            this.resultingJSON.AccountDetails
          );
          this._commercialService.setCommercial();

          return this.resultingJSON;
        } else {
          this.getAllAccountDetails();
        }
      },
      (error) => {
        console.log("Error: " + error);
        return {};
      }
    );
    return this.resultingJSON;
  }

  private doRedirectAfterLogin() {
    if (this.user.isCustomerService) {
      this.showContent = true;
      if (!localStorage.getItem("isCustomerService008c084!1")) {
        localStorage.setItem("isCustomerService008c084!1", "true");
      }
      return;
    }
    if (this.determineIfAccountHasPasses()) {
      this._router.navigateByUrl("/accountsetup");
    } else if (this.determineIfBillingAddressExistsInCustomerIdList()) {
      this._router.navigateByUrl("/addcreditcard");
    } else {
      this.showContent = true;
    }
  }

  public determineIfBillingAddressExistsInCustomerIdList() {
    let doRedirect = true;
    for (const customerId of this.user.customerIdArray) {
      if (customerId.BillingAddress.Street !== "") {
        doRedirect = false;
        break;
      }
    }
    return doRedirect;
  }

  public determineIfAccountHasPasses() {
    let doRedirect = true;
    for (const accountId of this.user.accountSummaryArray) {
      console.log(accountId);
      if (accountId) {
        doRedirect = false;
        break;
      }
    }
    return doRedirect;
  }

  private determineIfTokenExpired() {
    const expires = localStorage.getItem(Constants.EXPIRATION)
      ? moment(localStorage.getItem(Constants.EXPIRATION))
      : moment(sessionStorage.getItem(Constants.EXPIRATION));
    const today = moment();

    if (expires.diff(today) < 0) {
      return true;
    } else {
      return false;
    }
  }

  getCreditCards(): boolean {
    const creditCardUrl = "portfolios/CreditCards";
    let data: string;
    let cardResult: any;
    if (this.user.customerIdArray[this.user.customerIndex] == undefined) {
      return;
    }
    data = JSON.stringify({
      CustomerId: this.user.customerIdArray[this.user.customerIndex].Id,
      CardId: 0,
      AccountId: 0,
    });
    this.authenticatedPost(creditCardUrl, data).subscribe(
      (result) => {
        console.log(result);
        cardResult = result;
        this._service.emptyCreditCardArray();
        for (const card of cardResult) {
          this._service.addCreditCard(
            card.creditcardid,
            card.cardnumber,
            card.expires,
            card.cvv,
            card.isprimary,
            card.token
          );
        }
        return true;
      },
      (error) => {
        console.log("Error: " + error);
        return false;
      }
    );
    return false;
  }

  getDetailsFlag() {
    return this.detailsFlagChange$;
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/core/services/auth-guard.service.ts